import React from "react";
import { useSelector } from "react-redux";
import "./_PriceBoxGas.scss";

function PriceBoxGas() {
  const saldoPositivo = useSelector((user) => user?.gas?.info?.pricelist_mono);
  const saldoNegativo = useSelector(
    (user) => user.user.nuoviDatiContratto.mono_negativo
  );
  const opzioneTariffaria = useSelector(
    (user) => user.user.info.opzione_tariffaria
  );
  const quotaFissaPos = useSelector((user) => user?.gas?.info?.pricelist_qf);
  const quotaFissaNeg = useSelector(
    (user) => user.user.nuoviDatiContratto.qf_negativo
  );

  return (
    <>
      {saldoPositivo ? (
        <div className="priceBox">
          <p className="label">Prezzo</p>
          <div className="neutral">
            {/* <p className='price'>{parseFloat(saldoNegativo).toFixed(2).replace(/\./g, ",")}<span> €/kWh </span> {opzioneTariffaria && opzioneTariffaria !== 'D2' ? <span className='quotaFissa'>+{parseFloat(quotaFissaNeg).toFixed(2).replace(/\./g, ",")}€ al giorno</span> : null}</p> */}
            <p className="price">
              {parseFloat(saldoPositivo).toFixed(2).replace(/\./g, ",")}{" "}
              <span> €/msc </span>{" "}
              <span className="quotaFissa" style={{ fontWeight: "500" }}>
                + {parseFloat(quotaFissaPos).toFixed(2).replace(/\./g, ",")}{" "}
                €/mese (Canone Fisso)
              </span>
            </p>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default PriceBoxGas;
